<generic-search-results [showHeader]="false" [showCounter]="false" [title]="''" [records]="usersUpdateDetails"
    [displayedColumns]="userColumns" [selectableRecords]="false" [allowLocalFilter]="false"></generic-search-results>